import { useContext } from 'react';
import intl from 'react-intl-universal';
import { AppliedFilters, tailwindOverride } from '@getsynapse/design-system';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateDashboardFilters,
  dashboardFiltersSelectors,
} from 'state/normalized/dashboard/dashboardFiltersSlice';
import { dashboardSelectors } from 'state/normalized/dashboard/dashboardSlice';
import { DashboardContext } from 'Pages/DashboardsDetailsPage/DashboardContext';
import { RootState } from 'state/store';
import { FormattedFilters } from 'utils/types/dashboardFilters';

const DashboardAppliedFiltersTags = () => {
  const dispatch = useDispatch();
  const { dashboardId } = useContext(DashboardContext);
  const { canFilter } = useSelector((state: RootState) =>
    dashboardSelectors.selectDashboardAffordanceFlags(state, dashboardId)
  );
  const appliedFormattedFilters = useSelector((state: RootState) =>
    dashboardFiltersSelectors.selectFormattedAppliedFiltersById(
      state,
      dashboardId
    )
  );
  const appliedFilters = useSelector((state: RootState) =>
    dashboardFiltersSelectors.selectAppliedFiltersById(state, dashboardId)
  );

  const handleRemoveFilter = (filter: FormattedFilters) => {
    if (!canFilter) return;

    const updatedFilters = { ...appliedFilters };

    switch (filter.key) {
      case 'timeframe':
        delete updatedFilters.startDate;
        delete updatedFilters.endDate;
        break;
      default:
        if (updatedFilters.hasOwnProperty(filter.key)) {
          delete updatedFilters[filter.key];
        }
        break;
    }

    dispatch(
      updateDashboardFilters({
        dashboardId,
        filters: updatedFilters,
      })
    );
  };

  const handleClearAllFilters = () => {
    if (!canFilter) return;
    dispatch(updateDashboardFilters({ dashboardId, filters: {} }));
  };

  return (
    <AppliedFilters<FormattedFilters>
      filters={appliedFormattedFilters}
      onRemoveFilter={handleRemoveFilter}
      onClearAll={handleClearAllFilters}
      className={tailwindOverride('border-primary-lighter-two z-20')}
      data-testid='applied-dashboard-filters-tags'
      title={intl.get('FILTER_PANEL.FILTERS_APPLIED')}
      clearAllLabel={intl.get('FILTER_PANEL.CLEAR_ALL')}
      readOnly={!canFilter}
    />
  );
};

export default DashboardAppliedFiltersTags;
